import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const tiers = [
  {
    name: "Landing pages",
    price: "Desde $499",
    unit: "USD",
    desc: "Una página enfocada en un solo objetivo de conversión.",
    features: ["Copy de conversión", "Medición básica", "Dominio + despliegue", "1 ronda de ajustes"],
    highlight: false,
  },
  {
    name: "Sitios web informativos",
    price: "Desde $800",
    unit: "USD",
    desc: "Varias secciones para posicionar y dar confianza.",
    features: ["Multi-sección", "SEO base", "Formulario de contacto", "Editable y veloz"],
    highlight: false,
  },
  {
    name: "Tiendas en línea",
    price: "Desde $1,250",
    unit: "USD",
    desc: "Vende directo al público con una tienda que convierte.",
    features: ["Catálogo + carrito", "Pagos en línea", "Shopify o a medida", "Panel de productos"],
    highlight: true,
  },
  {
    name: "Sistemas / apps a medida",
    price: "Desde $1,250",
    unit: "USD",
    desc: "Software propio para tu operación. Requiere cotización.",
    features: ["Paneles y roles", "Lógica de negocio", "Integraciones", "Alcance a medida"],
    highlight: false,
  },
];

export const Pricing = ({ onBook }) => (
  <section id="precios" data-testid="pricing" className="relative z-10 py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline mb-3">Precios orientativos</p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-[1.05]">
          Inversión clara por tipo de proyecto
        </h2>
        <p className="mt-5 text-zinc-400 max-w-xl">
          Precios de arranque como referencia. El monto final depende del alcance y lo
          definimos juntos en la llamada de diagnóstico.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {tiers.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <div
              data-testid={`pricing-${i}`}
              className={`rounded-3xl p-7 h-full flex flex-col ${
                t.highlight ? "bg-[var(--magenta)]/10 border border-[var(--magenta)]/40" : "glass"
              }`}
            >
              {t.highlight && (
                <span className="self-start rounded-full bg-[var(--magenta)] text-white text-[0.7rem] font-semibold px-3 py-1 mb-4">
                  Más solicitado
                </span>
              )}
              <h3 className="font-display font-semibold text-xl leading-tight min-h-[3rem]">{t.name}</h3>
              <div className="mt-3 flex items-baseline gap-1.5">
                <span className="font-display text-2xl font-bold text-white">{t.price}</span>
                <span className="text-xs text-zinc-500">{t.unit}</span>
              </div>
              <p className="mt-3 text-sm text-zinc-400 min-h-[3.5rem]">{t.desc}</p>
              <ul className="mt-5 space-y-2.5 flex-1">
                {t.features.map((f) => (
                  <li key={f} className="flex items-center gap-2.5 text-sm text-zinc-300">
                    <Check size={15} className="text-[var(--magenta)] shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={onBook}
                data-testid={`pricing-cta-${i}`}
                className={`mt-6 rounded-full font-semibold px-5 py-3 text-sm hover-lift ${
                  t.highlight
                    ? "bg-[var(--magenta)] text-white hover:magenta-glow"
                    : "glass text-white hover:border-white/25 transition-colors duration-300"
                }`}
              >
                Cotizar
              </button>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-6 text-center text-sm text-zinc-500">
          Todos los proyectos se cotizan a medida según alcance. Los precios mostrados son el punto de partida.
        </p>
      </Reveal>
    </div>
  </section>
);
